// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Compact toolbar buttons: target common header bar classes and optional .toolbar-compact */
.bg-light.border.rounded.shadow-sm.py-2.px-2 .btn,
.bg-light.border.rounded.shadow-sm.py-1.px-2 .btn,
.bg-light.py-2.px-2 .btn,
.bg-light.py-1.px-2 .btn,
.toolbar-compact .btn {
  padding: 0.22rem 0.4rem !important;
  font-size: 0.75rem !important;
  line-height: 1 !important;
  min-width: 36px;
}

/* Slightly smaller icons inside toolbar buttons */
.toolbar-compact .btn i,
.bg-light.border.rounded.shadow-sm.py-2.px-2 .btn i,
.bg-light.border.rounded.shadow-sm.py-1.px-2 .btn i,
.bg-light.py-2.px-2 .btn i,
.bg-light.py-1.px-2 .btn i {
  font-size: 0.85rem !important;
}

/* Compact select used for filters */
.filter-select-compact.form-select {
  padding: 0.18rem 0.35rem !important;
  font-size: 0.78rem !important;
  height: calc(1.5em + 0.2rem) !important;
  line-height: 1 !important;
  vertical-align: middle !important;
  display: inline-flex !important;
  align-items: center !important;
}

.filter-select-very-compact.form-select {
  padding: 0.12rem 0.28rem !important;
  font-size: 0.72rem !important;
  height: calc(1.3em + 0.16rem) !important;
}

/* Compact input styles for toolbar text filters */
.filter-input-compact.form-control,
.filter-input-compact.form-control-sm,
.filter-input-compact.form-select,
.filter-input-compact.form-select-sm {
  padding: 0.1rem 0.35rem !important;
  font-size: 0.78rem !important;
  height: 1.6rem !important;
  line-height: 1 !important;
  box-sizing: border-box !important;
}

.filter-input-very-compact.form-control,
.filter-input-very-compact.form-control-sm {
  padding: 0.12rem 0.28rem !important;
  font-size: 0.72rem !important;
  height: calc(1.3em + 0.16rem) !important;
  line-height: 1 !important;
}

/* Keep input rounding and remove box-shadow to avoid visual gaps */
.input-group .filter-input-compact {
  box-shadow: none !important;
  border-top-right-radius: 0.375rem !important;
  border-bottom-right-radius: 0.375rem !important;
  height: 1.6rem !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  box-sizing: border-box !important;
  vertical-align: middle !important;
  border-color: var(--bs-border-color, #ced4da) !important;
}

/* Focus state: highlight input when it receives focus */
.input-group .filter-input-compact:focus {
  border-color: var(--bs-primary) !important;
  box-shadow: none !important;
}

/* Align the input-group text (icon) with compact inputs */
.input-group .input-group-text {
  padding: 0 0.4rem !important;
  height: 1.6rem !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  line-height: 1 !important;
  box-sizing: border-box !important;
}
.input-group-sm .input-group-text {
  padding: 0 0.35rem !important;
  height: 1.6rem !important;
  box-sizing: border-box !important;
}

/* Button used to clear compact filters: match input compact height and visuals */
.filter-clear-btn {
  height: 1.6rem !important;
  padding: 0 0.35rem !important;
  font-size: 0.78rem !important;
  line-height: 1 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  vertical-align: middle !important;
  box-sizing: border-box !important;
}

/* Ensure toolbar header buttons are vertically centered */
.bg-light.border.rounded.shadow-sm.py-2.px-2 .btn,
.bg-light.border.rounded.shadow-sm.py-1.px-2 .btn,
.bg-light.py-2.px-2 .btn,
.bg-light.py-1.px-2 .btn,
.toolbar-compact .btn {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  /* Uniform vertical padding to center text relative to button borders */
  padding-top: 0.22rem !important;
  padding-bottom: 0.22rem !important;
  box-sizing: border-box !important;
  line-height: 1 !important;
}

/* Ensure icon and text appear centered as a unit */
.bg-light.border.rounded.shadow-sm.py-2.px-2 .btn,
.bg-light.border.rounded.shadow-sm.py-1.px-2 .btn,
.bg-light.py-2.px-2 .btn,
.bg-light.py-1.px-2 .btn,
.toolbar-compact .btn {
  gap: 0.35rem !important;
  text-align: center !important;
  padding-left: 0.4rem !important;
  padding-right: 0.4rem !important;
}

/* Normalize icon spacing inside these toolbar buttons */
.bg-light.border.rounded.shadow-sm.py-2.px-2 .btn i,
.bg-light.border.rounded.shadow-sm.py-1.px-2 .btn i,
.bg-light.py-2.px-2 .btn i,
.bg-light.py-1.px-2 .btn i,
.toolbar-compact .btn i {
  margin: 0 0.12rem 0 0 !important;
  line-height: 1 !important;
  display: inline-flex !important;
  align-items: center !important;
}

/* Slightly tighter gap between icon and text */
.bg-light.border.rounded.shadow-sm.py-2.px-2 .btn,
.bg-light.border.rounded.shadow-sm.py-1.px-2 .btn,
.bg-light.py-2.px-2 .btn,
.bg-light.py-1.px-2 .btn,
.toolbar-compact .btn {
  gap: 0.18rem !important;
}

/* If button contains text nodes without a wrapper, ensure baseline centering by forcing small adjustment */
.bg-light.border.rounded.shadow-sm.py-2.px-2 .btn,
.bg-light.py-2.px-2 .btn,
.toolbar-compact .btn {
  align-items: center !important;
}

/* Ensure input-group and its children are vertically centered in compact headers */
.bg-light.border.rounded.shadow-sm.py-2.px-2 .input-group,
.bg-light.border.rounded.shadow-sm.py-1.px-2 .input-group,
.bg-light.py-2.px-2 .input-group,
.bg-light.py-1.px-2 .input-group,
.toolbar-compact .input-group {
  display: inline-flex !important;
  align-items: center !important;
}

/* Force smaller funnel icon and slight vertical nudge for perfect alignment in ACP */
.input-group .input-group-text > i.bi,
.input-group .input-group-text > i {
  font-size: 10px !important;
  transform: translateY(0.5px) !important;
  line-height: 1 !important;
  display: inline-block !important;
}

/* uex_web-inspired toolbar tweaks: separator size and search positioning */
@media (min-width: 768px) {
  .botao-grid-2col {
    gap: 0.35rem !important;
    align-items: center !important;
    flex-wrap: wrap !important;
  }
  .botao-grid-2col > .toolbar-separator {
    width: 1px !important;
    height: 1.6rem !important;
    background: rgba(0, 0, 0, 0.18) !important;
    margin: 0 0.25rem !important;
  }
  .botao-grid-2col > .toolbar-search {
    margin-left: auto !important;
    max-width: 320px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/service/components/css/Toolbar.css"],"names":[],"mappings":"AAAA,4FAA4F;AAC5F;;;;;EAKE,kCAAkC;EAClC,6BAA6B;EAC7B,yBAAyB;EACzB,eAAe;AACjB;;AAEA,kDAAkD;AAClD;;;;;EAKE,6BAA6B;AAC/B;;AAEA,oCAAoC;AACpC;EACE,mCAAmC;EACnC,6BAA6B;EAC7B,uCAAuC;EACvC,yBAAyB;EACzB,iCAAiC;EACjC,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,6BAA6B;EAC7B,wCAAwC;AAC1C;;AAEA,kDAAkD;AAClD;;;;EAIE,kCAAkC;EAClC,6BAA6B;EAC7B,yBAAyB;EACzB,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;;EAEE,mCAAmC;EACnC,6BAA6B;EAC7B,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA,mEAAmE;AACnE;EACE,2BAA2B;EAC3B,4CAA4C;EAC5C,+CAA+C;EAC/C,yBAAyB;EACzB,yBAAyB;EACzB,4BAA4B;EAC5B,iCAAiC;EACjC,iCAAiC;EACjC,wDAAwD;AAC1D;;AAEA,wDAAwD;AACxD;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA,0DAA0D;AAC1D;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,yBAAyB;EACzB,iCAAiC;AACnC;AACA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA,iFAAiF;AACjF;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,6BAA6B;EAC7B,yBAAyB;EACzB,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA,0DAA0D;AAC1D;;;;;EAKE,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,uEAAuE;EACvE,+BAA+B;EAC/B,kCAAkC;EAClC,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA,mDAAmD;AACnD;;;;;EAKE,uBAAuB;EACvB,6BAA6B;EAC7B,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA,wDAAwD;AACxD;;;;;EAKE,gCAAgC;EAChC,yBAAyB;EACzB,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA,+CAA+C;AAC/C;;;;;EAKE,uBAAuB;AACzB;;AAEA,2GAA2G;AAC3G;;;EAGE,8BAA8B;AAChC;;AAEA,mFAAmF;AACnF;;;;;EAKE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA,qFAAqF;AACrF;;EAEE,0BAA0B;EAC1B,uCAAuC;EACvC,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA,2EAA2E;AAC3E;EACE;IACE,uBAAuB;IACvB,8BAA8B;IAC9B,0BAA0B;EAC5B;EACA;IACE,qBAAqB;IACrB,yBAAyB;IACzB,0CAA0C;IAC1C,4BAA4B;EAC9B;EACA;IACE,4BAA4B;IAC5B,2BAA2B;EAC7B;AACF","sourcesContent":["/* Compact toolbar buttons: target common header bar classes and optional .toolbar-compact */\n.bg-light.border.rounded.shadow-sm.py-2.px-2 .btn,\n.bg-light.border.rounded.shadow-sm.py-1.px-2 .btn,\n.bg-light.py-2.px-2 .btn,\n.bg-light.py-1.px-2 .btn,\n.toolbar-compact .btn {\n  padding: 0.22rem 0.4rem !important;\n  font-size: 0.75rem !important;\n  line-height: 1 !important;\n  min-width: 36px;\n}\n\n/* Slightly smaller icons inside toolbar buttons */\n.toolbar-compact .btn i,\n.bg-light.border.rounded.shadow-sm.py-2.px-2 .btn i,\n.bg-light.border.rounded.shadow-sm.py-1.px-2 .btn i,\n.bg-light.py-2.px-2 .btn i,\n.bg-light.py-1.px-2 .btn i {\n  font-size: 0.85rem !important;\n}\n\n/* Compact select used for filters */\n.filter-select-compact.form-select {\n  padding: 0.18rem 0.35rem !important;\n  font-size: 0.78rem !important;\n  height: calc(1.5em + 0.2rem) !important;\n  line-height: 1 !important;\n  vertical-align: middle !important;\n  display: inline-flex !important;\n  align-items: center !important;\n}\n\n.filter-select-very-compact.form-select {\n  padding: 0.12rem 0.28rem !important;\n  font-size: 0.72rem !important;\n  height: calc(1.3em + 0.16rem) !important;\n}\n\n/* Compact input styles for toolbar text filters */\n.filter-input-compact.form-control,\n.filter-input-compact.form-control-sm,\n.filter-input-compact.form-select,\n.filter-input-compact.form-select-sm {\n  padding: 0.1rem 0.35rem !important;\n  font-size: 0.78rem !important;\n  height: 1.6rem !important;\n  line-height: 1 !important;\n  box-sizing: border-box !important;\n}\n\n.filter-input-very-compact.form-control,\n.filter-input-very-compact.form-control-sm {\n  padding: 0.12rem 0.28rem !important;\n  font-size: 0.72rem !important;\n  height: calc(1.3em + 0.16rem) !important;\n  line-height: 1 !important;\n}\n\n/* Keep input rounding and remove box-shadow to avoid visual gaps */\n.input-group .filter-input-compact {\n  box-shadow: none !important;\n  border-top-right-radius: 0.375rem !important;\n  border-bottom-right-radius: 0.375rem !important;\n  height: 1.6rem !important;\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n  box-sizing: border-box !important;\n  vertical-align: middle !important;\n  border-color: var(--bs-border-color, #ced4da) !important;\n}\n\n/* Focus state: highlight input when it receives focus */\n.input-group .filter-input-compact:focus {\n  border-color: var(--bs-primary) !important;\n  box-shadow: none !important;\n}\n\n/* Align the input-group text (icon) with compact inputs */\n.input-group .input-group-text {\n  padding: 0 0.4rem !important;\n  height: 1.6rem !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  line-height: 1 !important;\n  box-sizing: border-box !important;\n}\n.input-group-sm .input-group-text {\n  padding: 0 0.35rem !important;\n  height: 1.6rem !important;\n  box-sizing: border-box !important;\n}\n\n/* Button used to clear compact filters: match input compact height and visuals */\n.filter-clear-btn {\n  height: 1.6rem !important;\n  padding: 0 0.35rem !important;\n  font-size: 0.78rem !important;\n  line-height: 1 !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  vertical-align: middle !important;\n  box-sizing: border-box !important;\n}\n\n/* Ensure toolbar header buttons are vertically centered */\n.bg-light.border.rounded.shadow-sm.py-2.px-2 .btn,\n.bg-light.border.rounded.shadow-sm.py-1.px-2 .btn,\n.bg-light.py-2.px-2 .btn,\n.bg-light.py-1.px-2 .btn,\n.toolbar-compact .btn {\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  /* Uniform vertical padding to center text relative to button borders */\n  padding-top: 0.22rem !important;\n  padding-bottom: 0.22rem !important;\n  box-sizing: border-box !important;\n  line-height: 1 !important;\n}\n\n/* Ensure icon and text appear centered as a unit */\n.bg-light.border.rounded.shadow-sm.py-2.px-2 .btn,\n.bg-light.border.rounded.shadow-sm.py-1.px-2 .btn,\n.bg-light.py-2.px-2 .btn,\n.bg-light.py-1.px-2 .btn,\n.toolbar-compact .btn {\n  gap: 0.35rem !important;\n  text-align: center !important;\n  padding-left: 0.4rem !important;\n  padding-right: 0.4rem !important;\n}\n\n/* Normalize icon spacing inside these toolbar buttons */\n.bg-light.border.rounded.shadow-sm.py-2.px-2 .btn i,\n.bg-light.border.rounded.shadow-sm.py-1.px-2 .btn i,\n.bg-light.py-2.px-2 .btn i,\n.bg-light.py-1.px-2 .btn i,\n.toolbar-compact .btn i {\n  margin: 0 0.12rem 0 0 !important;\n  line-height: 1 !important;\n  display: inline-flex !important;\n  align-items: center !important;\n}\n\n/* Slightly tighter gap between icon and text */\n.bg-light.border.rounded.shadow-sm.py-2.px-2 .btn,\n.bg-light.border.rounded.shadow-sm.py-1.px-2 .btn,\n.bg-light.py-2.px-2 .btn,\n.bg-light.py-1.px-2 .btn,\n.toolbar-compact .btn {\n  gap: 0.18rem !important;\n}\n\n/* If button contains text nodes without a wrapper, ensure baseline centering by forcing small adjustment */\n.bg-light.border.rounded.shadow-sm.py-2.px-2 .btn,\n.bg-light.py-2.px-2 .btn,\n.toolbar-compact .btn {\n  align-items: center !important;\n}\n\n/* Ensure input-group and its children are vertically centered in compact headers */\n.bg-light.border.rounded.shadow-sm.py-2.px-2 .input-group,\n.bg-light.border.rounded.shadow-sm.py-1.px-2 .input-group,\n.bg-light.py-2.px-2 .input-group,\n.bg-light.py-1.px-2 .input-group,\n.toolbar-compact .input-group {\n  display: inline-flex !important;\n  align-items: center !important;\n}\n\n/* Force smaller funnel icon and slight vertical nudge for perfect alignment in ACP */\n.input-group .input-group-text > i.bi,\n.input-group .input-group-text > i {\n  font-size: 10px !important;\n  transform: translateY(0.5px) !important;\n  line-height: 1 !important;\n  display: inline-block !important;\n}\n\n/* uex_web-inspired toolbar tweaks: separator size and search positioning */\n@media (min-width: 768px) {\n  .botao-grid-2col {\n    gap: 0.35rem !important;\n    align-items: center !important;\n    flex-wrap: wrap !important;\n  }\n  .botao-grid-2col > .toolbar-separator {\n    width: 1px !important;\n    height: 1.6rem !important;\n    background: rgba(0, 0, 0, 0.18) !important;\n    margin: 0 0.25rem !important;\n  }\n  .botao-grid-2col > .toolbar-search {\n    margin-left: auto !important;\n    max-width: 320px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
